//CA2

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import { Refresh, AccessTime } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { GeneralError } from '../../Utility/Constants';
import { getCocaAnnualReportDetails, clearData } from '../../Redux/CocaAnnualReports/CocaAnnual2Slice';
import { CocaAnnualReportDetail } from '../../Table/TableColumn';
import Spinner from '../../Spinner/Spinner';
import ReportsTable from '../../Table/ReportsTable';
import { triggerDatabricksJobData } from '../../Redux/DataBricks/CocaDataBricksSlice';

function CocaAnnual2() {
    const dispatch = useDispatch();
    const isAnnualReportDataLoading = useSelector(state => state.cocaAnnual2.annualReportData.loading);
    const annualReportDataError = useSelector(state => state.cocaAnnual2.annualReportData.error);
    const lastRefreshedDate = useSelector(state => state.cocaAnnual2.annualReportData.lastRefreshedDate);
    const [initialFetchDone, setInitialFetchDone] = useState(false);

    useEffect(() => {
        if (annualReportDataError) {
            toast.error(GeneralError);
        }
    }, [annualReportDataError]);

    const handleRefresh = () => {
        dispatch(getCocaAnnualReportDetails());
    };

    useEffect(() => {
        dispatch(clearData());
        dispatch(getCocaAnnualReportDetails()).finally(() => setInitialFetchDone(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCocaAnnualRunJob = async () => {
        try {
            const action = await dispatch(triggerDatabricksJobData(1));
            if (triggerDatabricksJobData.fulfilled.match(action)) {
                toast.success(`Databricks job started (Run ID: ${action.payload.runId || 'N/A'})`);
            } else if (triggerDatabricksJobData.rejected.match(action)) {
                toast.error(action.payload || 'Failed to start Databricks job');
            }
        }
        catch (error) {
            toast.error('Failed to trigger Databricks job');
            console.error('Error triggering Databricks job:', error);
        }
    };

    return (
        <>
            {(!initialFetchDone && isAnnualReportDataLoading) && <Spinner />}
            <Box sx={{ margin: '20px 0' }}>
                <Button variant="contained" color="primary" onClick={handleCocaAnnualRunJob}>Start New Run</Button>
            </Box>
            <Box sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                paddingBottom: '16px',
                gap: 2
            }}>
                <Button
                    variant="outlined"
                    size="small"
                    disabled={true}
                    startIcon={<AccessTime />}
                    sx={{ minWidth: '180px', fontWeight: 'bold' }}
                >
                    {`Last Updated: ${lastRefreshedDate ? lastRefreshedDate.split('.')[0] : ''}`}
                </Button>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={handleRefresh}
                    disabled={isAnnualReportDataLoading}
                    startIcon={<Refresh />}
                    sx={{ minWidth: '120px', fontWeight: 'bold' }}
                >
                    {isAnnualReportDataLoading ? 'Refreshing...' : 'Refresh'}
                </Button>
            </Box>
            <ReportsTable
                tableName={'Annual Report'}
                tableIndex={1}
                columns={CocaAnnualReportDetail}
                dataSource={'cocaAnnualReport'}
                loading={isAnnualReportDataLoading}
                sliceName={'cocaAnnual2'}
            />
        </>
    );
}

export default CocaAnnual2;